import { render, staticRenderFns } from "./AccessLogo.vue?vue&type=template&id=133d87df&"
import script from "./AccessLogo.vue?vue&type=script&lang=js&"
export * from "./AccessLogo.vue?vue&type=script&lang=js&"
import style0 from "./AccessLogo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/frontend/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('133d87df')) {
      api.createRecord('133d87df', component.options)
    } else {
      api.reload('133d87df', component.options)
    }
    module.hot.accept("./AccessLogo.vue?vue&type=template&id=133d87df&", function () {
      api.rerender('133d87df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AccessLogo.vue"
export default component.exports